import { useCallback, useMemo } from 'react';
import { ALLOWED_EXTERNAL_CONTROLS } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/constants.tsx';
import type { ExternalControlsFieldAPI } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/types.tsx';
import type { FormAPI } from './types.tsx';

export const useExternalControlsAPI = ({ getFormState, setFieldValue }: FormAPI) => {
	const getFormFieldValue = useCallback(
		(fieldId: string): unknown => getFormState()?.values[fieldId],
		[getFormState],
	);

	const fieldAPI = useMemo(() => {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		const allowedFieldAPI = {} as ExternalControlsFieldAPI;

		ALLOWED_EXTERNAL_CONTROLS.FIELD_IDS.forEach((fieldId) => {
			allowedFieldAPI[fieldId] = {
				getValue: () => getFormFieldValue(fieldId),
				setValue: (value) => setFieldValue(fieldId, value),
			};
		});

		return allowedFieldAPI;
	}, [setFieldValue, getFormFieldValue]);

	return {
		fieldAPI,
		getFormFieldValue,
	};
};
